/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserIndexRouteImport } from './routes/user/index'
import { Route as RealassetsIndexRouteImport } from './routes/realassets/index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as MapIndexRouteImport } from './routes/map/index'
import { Route as AISearchIndexRouteImport } from './routes/AISearch/index'
import { Route as AuthSignInRouteImport } from './routes/auth/signIn'
import { Route as AuthCliRouteImport } from './routes/auth/cli'
import { Route as UserUserIdIndexRouteImport } from './routes/user/$userId/index'
import { Route as RealassetsPublicIdIndexRouteImport } from './routes/realassets/$publicId/index'
import { Route as OrganizationsIdIndexRouteImport } from './routes/organizations/$id/index'
import { Route as MockRovAssetsLoweringIndexRouteImport } from './routes/mockRovAssets/$lowering/index'
import { Route as DataVolumesIndexRouteImport } from './routes/data/volumes/index'
import { Route as DataSetsIndexRouteImport } from './routes/data/sets/index'
import { Route as DataBrowseIndexRouteImport } from './routes/data/browse/index'
import { Route as AdminStorageOpsIndexRouteImport } from './routes/admin/storage-ops/index'
import { Route as AdminFolderConfigIndexRouteImport } from './routes/admin/folder-config/index'
import { Route as DataAssetsSearchRouteImport } from './routes/data/assets/search'
import { Route as RealassetsPublicIdDeploymentPublicIdIndexRouteImport } from './routes/realassets/$publicId/$deploymentPublicId/index'
import { Route as MockRovAssetsLoweringDigitalTwinIndexRouteImport } from './routes/mockRovAssets/$lowering/digitalTwin/index'
import { Route as DataVolumesPublicIdIndexRouteImport } from './routes/data/volumes/$publicId/index'
import { Route as DataSetsPublicIdIndexRouteImport } from './routes/data/sets/$publicId/index'
import { Route as AuthProviderCookieCallbackRouteImport } from './routes/auth/$provider/cookie/callback'
import { Route as AuthProviderBearerCallbackRouteImport } from './routes/auth/$provider/bearer/callback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => rootRouteImport,
} as any)
const RealassetsIndexRoute = RealassetsIndexRouteImport.update({
  id: '/realassets/',
  path: '/realassets/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const MapIndexRoute = MapIndexRouteImport.update({
  id: '/map/',
  path: '/map/',
  getParentRoute: () => rootRouteImport,
} as any)
const AISearchIndexRoute = AISearchIndexRouteImport.update({
  id: '/AISearch/',
  path: '/AISearch/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/signIn',
  path: '/auth/signIn',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCliRoute = AuthCliRouteImport.update({
  id: '/auth/cli',
  path: '/auth/cli',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUserIdIndexRoute = UserUserIdIndexRouteImport.update({
  id: '/user/$userId/',
  path: '/user/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const RealassetsPublicIdIndexRoute = RealassetsPublicIdIndexRouteImport.update({
  id: '/realassets/$publicId/',
  path: '/realassets/$publicId/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIdIndexRoute = OrganizationsIdIndexRouteImport.update({
  id: '/organizations/$id/',
  path: '/organizations/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const MockRovAssetsLoweringIndexRoute =
  MockRovAssetsLoweringIndexRouteImport.update({
    id: '/mockRovAssets/$lowering/',
    path: '/mockRovAssets/$lowering/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DataVolumesIndexRoute = DataVolumesIndexRouteImport.update({
  id: '/data/volumes/',
  path: '/data/volumes/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataSetsIndexRoute = DataSetsIndexRouteImport.update({
  id: '/data/sets/',
  path: '/data/sets/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataBrowseIndexRoute = DataBrowseIndexRouteImport.update({
  id: '/data/browse/',
  path: '/data/browse/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStorageOpsIndexRoute = AdminStorageOpsIndexRouteImport.update({
  id: '/admin/storage-ops/',
  path: '/admin/storage-ops/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFolderConfigIndexRoute = AdminFolderConfigIndexRouteImport.update({
  id: '/admin/folder-config/',
  path: '/admin/folder-config/',
  getParentRoute: () => rootRouteImport,
} as any)
const DataAssetsSearchRoute = DataAssetsSearchRouteImport.update({
  id: '/data/assets/search',
  path: '/data/assets/search',
  getParentRoute: () => rootRouteImport,
} as any)
const RealassetsPublicIdDeploymentPublicIdIndexRoute =
  RealassetsPublicIdDeploymentPublicIdIndexRouteImport.update({
    id: '/realassets/$publicId/$deploymentPublicId/',
    path: '/realassets/$publicId/$deploymentPublicId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const MockRovAssetsLoweringDigitalTwinIndexRoute =
  MockRovAssetsLoweringDigitalTwinIndexRouteImport.update({
    id: '/mockRovAssets/$lowering/digitalTwin/',
    path: '/mockRovAssets/$lowering/digitalTwin/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DataVolumesPublicIdIndexRoute =
  DataVolumesPublicIdIndexRouteImport.update({
    id: '/data/volumes/$publicId/',
    path: '/data/volumes/$publicId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DataSetsPublicIdIndexRoute = DataSetsPublicIdIndexRouteImport.update({
  id: '/data/sets/$publicId/',
  path: '/data/sets/$publicId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthProviderCookieCallbackRoute =
  AuthProviderCookieCallbackRouteImport.update({
    id: '/auth/$provider/cookie/callback',
    path: '/auth/$provider/cookie/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthProviderBearerCallbackRoute =
  AuthProviderBearerCallbackRouteImport.update({
    id: '/auth/$provider/bearer/callback',
    path: '/auth/$provider/bearer/callback',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth/cli': typeof AuthCliRoute
  '/auth/signIn': typeof AuthSignInRoute
  '/AISearch/': typeof AISearchIndexRoute
  '/map/': typeof MapIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/realassets/': typeof RealassetsIndexRoute
  '/user/': typeof UserIndexRoute
  '/data/assets/search': typeof DataAssetsSearchRoute
  '/admin/folder-config/': typeof AdminFolderConfigIndexRoute
  '/admin/storage-ops/': typeof AdminStorageOpsIndexRoute
  '/data/browse/': typeof DataBrowseIndexRoute
  '/data/sets/': typeof DataSetsIndexRoute
  '/data/volumes/': typeof DataVolumesIndexRoute
  '/mockRovAssets/$lowering/': typeof MockRovAssetsLoweringIndexRoute
  '/organizations/$id/': typeof OrganizationsIdIndexRoute
  '/realassets/$publicId/': typeof RealassetsPublicIdIndexRoute
  '/user/$userId/': typeof UserUserIdIndexRoute
  '/auth/$provider/bearer/callback': typeof AuthProviderBearerCallbackRoute
  '/auth/$provider/cookie/callback': typeof AuthProviderCookieCallbackRoute
  '/data/sets/$publicId/': typeof DataSetsPublicIdIndexRoute
  '/data/volumes/$publicId/': typeof DataVolumesPublicIdIndexRoute
  '/mockRovAssets/$lowering/digitalTwin/': typeof MockRovAssetsLoweringDigitalTwinIndexRoute
  '/realassets/$publicId/$deploymentPublicId/': typeof RealassetsPublicIdDeploymentPublicIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/cli': typeof AuthCliRoute
  '/auth/signIn': typeof AuthSignInRoute
  '/AISearch': typeof AISearchIndexRoute
  '/map': typeof MapIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/realassets': typeof RealassetsIndexRoute
  '/user': typeof UserIndexRoute
  '/data/assets/search': typeof DataAssetsSearchRoute
  '/admin/folder-config': typeof AdminFolderConfigIndexRoute
  '/admin/storage-ops': typeof AdminStorageOpsIndexRoute
  '/data/browse': typeof DataBrowseIndexRoute
  '/data/sets': typeof DataSetsIndexRoute
  '/data/volumes': typeof DataVolumesIndexRoute
  '/mockRovAssets/$lowering': typeof MockRovAssetsLoweringIndexRoute
  '/organizations/$id': typeof OrganizationsIdIndexRoute
  '/realassets/$publicId': typeof RealassetsPublicIdIndexRoute
  '/user/$userId': typeof UserUserIdIndexRoute
  '/auth/$provider/bearer/callback': typeof AuthProviderBearerCallbackRoute
  '/auth/$provider/cookie/callback': typeof AuthProviderCookieCallbackRoute
  '/data/sets/$publicId': typeof DataSetsPublicIdIndexRoute
  '/data/volumes/$publicId': typeof DataVolumesPublicIdIndexRoute
  '/mockRovAssets/$lowering/digitalTwin': typeof MockRovAssetsLoweringDigitalTwinIndexRoute
  '/realassets/$publicId/$deploymentPublicId': typeof RealassetsPublicIdDeploymentPublicIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth/cli': typeof AuthCliRoute
  '/auth/signIn': typeof AuthSignInRoute
  '/AISearch/': typeof AISearchIndexRoute
  '/map/': typeof MapIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/realassets/': typeof RealassetsIndexRoute
  '/user/': typeof UserIndexRoute
  '/data/assets/search': typeof DataAssetsSearchRoute
  '/admin/folder-config/': typeof AdminFolderConfigIndexRoute
  '/admin/storage-ops/': typeof AdminStorageOpsIndexRoute
  '/data/browse/': typeof DataBrowseIndexRoute
  '/data/sets/': typeof DataSetsIndexRoute
  '/data/volumes/': typeof DataVolumesIndexRoute
  '/mockRovAssets/$lowering/': typeof MockRovAssetsLoweringIndexRoute
  '/organizations/$id/': typeof OrganizationsIdIndexRoute
  '/realassets/$publicId/': typeof RealassetsPublicIdIndexRoute
  '/user/$userId/': typeof UserUserIdIndexRoute
  '/auth/$provider/bearer/callback': typeof AuthProviderBearerCallbackRoute
  '/auth/$provider/cookie/callback': typeof AuthProviderCookieCallbackRoute
  '/data/sets/$publicId/': typeof DataSetsPublicIdIndexRoute
  '/data/volumes/$publicId/': typeof DataVolumesPublicIdIndexRoute
  '/mockRovAssets/$lowering/digitalTwin/': typeof MockRovAssetsLoweringDigitalTwinIndexRoute
  '/realassets/$publicId/$deploymentPublicId/': typeof RealassetsPublicIdDeploymentPublicIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/cli'
    | '/auth/signIn'
    | '/AISearch/'
    | '/map/'
    | '/organizations/'
    | '/realassets/'
    | '/user/'
    | '/data/assets/search'
    | '/admin/folder-config/'
    | '/admin/storage-ops/'
    | '/data/browse/'
    | '/data/sets/'
    | '/data/volumes/'
    | '/mockRovAssets/$lowering/'
    | '/organizations/$id/'
    | '/realassets/$publicId/'
    | '/user/$userId/'
    | '/auth/$provider/bearer/callback'
    | '/auth/$provider/cookie/callback'
    | '/data/sets/$publicId/'
    | '/data/volumes/$publicId/'
    | '/mockRovAssets/$lowering/digitalTwin/'
    | '/realassets/$publicId/$deploymentPublicId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/cli'
    | '/auth/signIn'
    | '/AISearch'
    | '/map'
    | '/organizations'
    | '/realassets'
    | '/user'
    | '/data/assets/search'
    | '/admin/folder-config'
    | '/admin/storage-ops'
    | '/data/browse'
    | '/data/sets'
    | '/data/volumes'
    | '/mockRovAssets/$lowering'
    | '/organizations/$id'
    | '/realassets/$publicId'
    | '/user/$userId'
    | '/auth/$provider/bearer/callback'
    | '/auth/$provider/cookie/callback'
    | '/data/sets/$publicId'
    | '/data/volumes/$publicId'
    | '/mockRovAssets/$lowering/digitalTwin'
    | '/realassets/$publicId/$deploymentPublicId'
  id:
    | '__root__'
    | '/'
    | '/auth/cli'
    | '/auth/signIn'
    | '/AISearch/'
    | '/map/'
    | '/organizations/'
    | '/realassets/'
    | '/user/'
    | '/data/assets/search'
    | '/admin/folder-config/'
    | '/admin/storage-ops/'
    | '/data/browse/'
    | '/data/sets/'
    | '/data/volumes/'
    | '/mockRovAssets/$lowering/'
    | '/organizations/$id/'
    | '/realassets/$publicId/'
    | '/user/$userId/'
    | '/auth/$provider/bearer/callback'
    | '/auth/$provider/cookie/callback'
    | '/data/sets/$publicId/'
    | '/data/volumes/$publicId/'
    | '/mockRovAssets/$lowering/digitalTwin/'
    | '/realassets/$publicId/$deploymentPublicId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthCliRoute: typeof AuthCliRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AISearchIndexRoute: typeof AISearchIndexRoute
  MapIndexRoute: typeof MapIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  RealassetsIndexRoute: typeof RealassetsIndexRoute
  UserIndexRoute: typeof UserIndexRoute
  DataAssetsSearchRoute: typeof DataAssetsSearchRoute
  AdminFolderConfigIndexRoute: typeof AdminFolderConfigIndexRoute
  AdminStorageOpsIndexRoute: typeof AdminStorageOpsIndexRoute
  DataBrowseIndexRoute: typeof DataBrowseIndexRoute
  DataSetsIndexRoute: typeof DataSetsIndexRoute
  DataVolumesIndexRoute: typeof DataVolumesIndexRoute
  MockRovAssetsLoweringIndexRoute: typeof MockRovAssetsLoweringIndexRoute
  OrganizationsIdIndexRoute: typeof OrganizationsIdIndexRoute
  RealassetsPublicIdIndexRoute: typeof RealassetsPublicIdIndexRoute
  UserUserIdIndexRoute: typeof UserUserIdIndexRoute
  AuthProviderBearerCallbackRoute: typeof AuthProviderBearerCallbackRoute
  AuthProviderCookieCallbackRoute: typeof AuthProviderCookieCallbackRoute
  DataSetsPublicIdIndexRoute: typeof DataSetsPublicIdIndexRoute
  DataVolumesPublicIdIndexRoute: typeof DataVolumesPublicIdIndexRoute
  MockRovAssetsLoweringDigitalTwinIndexRoute: typeof MockRovAssetsLoweringDigitalTwinIndexRoute
  RealassetsPublicIdDeploymentPublicIdIndexRoute: typeof RealassetsPublicIdDeploymentPublicIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/': {
      id: '/user/'
      path: '/user'
      fullPath: '/user/'
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/realassets/': {
      id: '/realassets/'
      path: '/realassets'
      fullPath: '/realassets/'
      preLoaderRoute: typeof RealassetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map/': {
      id: '/map/'
      path: '/map'
      fullPath: '/map/'
      preLoaderRoute: typeof MapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/AISearch/': {
      id: '/AISearch/'
      path: '/AISearch'
      fullPath: '/AISearch/'
      preLoaderRoute: typeof AISearchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signIn': {
      id: '/auth/signIn'
      path: '/auth/signIn'
      fullPath: '/auth/signIn'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/cli': {
      id: '/auth/cli'
      path: '/auth/cli'
      fullPath: '/auth/cli'
      preLoaderRoute: typeof AuthCliRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/$userId/': {
      id: '/user/$userId/'
      path: '/user/$userId'
      fullPath: '/user/$userId/'
      preLoaderRoute: typeof UserUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/realassets/$publicId/': {
      id: '/realassets/$publicId/'
      path: '/realassets/$publicId'
      fullPath: '/realassets/$publicId/'
      preLoaderRoute: typeof RealassetsPublicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$id/': {
      id: '/organizations/$id/'
      path: '/organizations/$id'
      fullPath: '/organizations/$id/'
      preLoaderRoute: typeof OrganizationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mockRovAssets/$lowering/': {
      id: '/mockRovAssets/$lowering/'
      path: '/mockRovAssets/$lowering'
      fullPath: '/mockRovAssets/$lowering/'
      preLoaderRoute: typeof MockRovAssetsLoweringIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/volumes/': {
      id: '/data/volumes/'
      path: '/data/volumes'
      fullPath: '/data/volumes/'
      preLoaderRoute: typeof DataVolumesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/sets/': {
      id: '/data/sets/'
      path: '/data/sets'
      fullPath: '/data/sets/'
      preLoaderRoute: typeof DataSetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/browse/': {
      id: '/data/browse/'
      path: '/data/browse'
      fullPath: '/data/browse/'
      preLoaderRoute: typeof DataBrowseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/storage-ops/': {
      id: '/admin/storage-ops/'
      path: '/admin/storage-ops'
      fullPath: '/admin/storage-ops/'
      preLoaderRoute: typeof AdminStorageOpsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/folder-config/': {
      id: '/admin/folder-config/'
      path: '/admin/folder-config'
      fullPath: '/admin/folder-config/'
      preLoaderRoute: typeof AdminFolderConfigIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/assets/search': {
      id: '/data/assets/search'
      path: '/data/assets/search'
      fullPath: '/data/assets/search'
      preLoaderRoute: typeof DataAssetsSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/realassets/$publicId/$deploymentPublicId/': {
      id: '/realassets/$publicId/$deploymentPublicId/'
      path: '/realassets/$publicId/$deploymentPublicId'
      fullPath: '/realassets/$publicId/$deploymentPublicId/'
      preLoaderRoute: typeof RealassetsPublicIdDeploymentPublicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mockRovAssets/$lowering/digitalTwin/': {
      id: '/mockRovAssets/$lowering/digitalTwin/'
      path: '/mockRovAssets/$lowering/digitalTwin'
      fullPath: '/mockRovAssets/$lowering/digitalTwin/'
      preLoaderRoute: typeof MockRovAssetsLoweringDigitalTwinIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/volumes/$publicId/': {
      id: '/data/volumes/$publicId/'
      path: '/data/volumes/$publicId'
      fullPath: '/data/volumes/$publicId/'
      preLoaderRoute: typeof DataVolumesPublicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data/sets/$publicId/': {
      id: '/data/sets/$publicId/'
      path: '/data/sets/$publicId'
      fullPath: '/data/sets/$publicId/'
      preLoaderRoute: typeof DataSetsPublicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$provider/cookie/callback': {
      id: '/auth/$provider/cookie/callback'
      path: '/auth/$provider/cookie/callback'
      fullPath: '/auth/$provider/cookie/callback'
      preLoaderRoute: typeof AuthProviderCookieCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$provider/bearer/callback': {
      id: '/auth/$provider/bearer/callback'
      path: '/auth/$provider/bearer/callback'
      fullPath: '/auth/$provider/bearer/callback'
      preLoaderRoute: typeof AuthProviderBearerCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthCliRoute: AuthCliRoute,
  AuthSignInRoute: AuthSignInRoute,
  AISearchIndexRoute: AISearchIndexRoute,
  MapIndexRoute: MapIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  RealassetsIndexRoute: RealassetsIndexRoute,
  UserIndexRoute: UserIndexRoute,
  DataAssetsSearchRoute: DataAssetsSearchRoute,
  AdminFolderConfigIndexRoute: AdminFolderConfigIndexRoute,
  AdminStorageOpsIndexRoute: AdminStorageOpsIndexRoute,
  DataBrowseIndexRoute: DataBrowseIndexRoute,
  DataSetsIndexRoute: DataSetsIndexRoute,
  DataVolumesIndexRoute: DataVolumesIndexRoute,
  MockRovAssetsLoweringIndexRoute: MockRovAssetsLoweringIndexRoute,
  OrganizationsIdIndexRoute: OrganizationsIdIndexRoute,
  RealassetsPublicIdIndexRoute: RealassetsPublicIdIndexRoute,
  UserUserIdIndexRoute: UserUserIdIndexRoute,
  AuthProviderBearerCallbackRoute: AuthProviderBearerCallbackRoute,
  AuthProviderCookieCallbackRoute: AuthProviderCookieCallbackRoute,
  DataSetsPublicIdIndexRoute: DataSetsPublicIdIndexRoute,
  DataVolumesPublicIdIndexRoute: DataVolumesPublicIdIndexRoute,
  MockRovAssetsLoweringDigitalTwinIndexRoute:
    MockRovAssetsLoweringDigitalTwinIndexRoute,
  RealassetsPublicIdDeploymentPublicIdIndexRoute:
    RealassetsPublicIdDeploymentPublicIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
